/** Angular */
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
/** Services */
import { BydHttpMockService } from './byd-http-mock.service';

@Injectable({
  providedIn: 'root',
})
export class BydHttpMockInterceptorService implements HttpInterceptor {
  /**
   * Creates an instance of BydHttpMockInterceptorService.
   *
   * @param bydHttpMockService the api http mock service
   */
  constructor(private bydHttpMockService: BydHttpMockService) {}

  /**
   * Intercepts http requests and mock responses.
   *
   * @param request the outgoing request to handle
   * @param next the next interceptor in the chain, or the backend if no interceptors in the chain.
   * @returns Observable<HttpEvent<any>>
   */
  // TODO Set the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<any>> {
    for (const httpMock of this.bydHttpMockService.injectedHttpMockToken) {
      if (request.url === httpMock.url) {
        return of(
          new HttpResponse({
            status: 200,
            body: httpMock.body,
          })
        );
      }
    }
    return next.handle(request);
  }
}
